<div class="pricelists-list-layout">
  <mat-form-field appearance="outline" class="searchbar">
    <input matInput [placeholder]="'pricelists.ui.cercaClienteContrattoProdotto' | transloco">
    <div matSuffix class="search-icon-wrapper">
      <i class="fa-regular fa-magnifying-glass"></i>
    </div>
  </mat-form-field>

  <mat-chip-listbox class="chip-list" [attr.aria-label]="'pricelists.ui.filtriListini' | transloco">
    <!-- TODO: Collegare chiamata api per generare le voci -->
    <mat-chip-option>{{ 'pricelists.ui.tutti6' | transloco }}</mat-chip-option>
    <mat-chip-option>{{ 'pricelists.ui.attivi3' | transloco }}</mat-chip-option>
    <mat-chip-option>{{ 'pricelists.ui.inApprovazione2' | transloco }}</mat-chip-option>
    <mat-chip-option>{{ 'pricelists.ui.inScadenza1' | transloco }}</mat-chip-option>
    <mat-chip-option>{{ 'pricelists.ui.scaduti1' | transloco }}</mat-chip-option>
  </mat-chip-listbox>

  <div class="elements-container">
    @for (item of mockItems; track item.id) {
      <div class="element">
      <!-- NB: Disabilitato router temporaneamente per nascondere dettaglio, al momento vuoto -->
      <!-- <div class="element" routerLink="/pricelists/detail"> -->
        <div class="content">
          <div class="body-medium">{{ item.numeroContratto }}</div>
          <div class="body-medium-emphasized">{{ item.cliente }}</div>
          <div class="body-small">
            {{ 'pricelists.ui.righe' | transloco: { value0: (item.inizio | translocoDate: { dateStyle: 'long' }), value1: (item.fine | translocoDate: { dateStyle: 'long' }), value2: (item.righe), value3: (item.agente) } }}
          </div>
        </div>

        <div class="badge">
          <span [class]="'status-badge status-' + item.stato + ' body-medium-emphasized'">
            {{ statusLabels[item.stato] }}
          </span>
        </div>
      </div>

      @if (!$last) {
        <mat-divider class="element-divider"></mat-divider>
      }
    }
  </div>
</div>
